import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../axiosConfig";
import WIPHeader from "../components/WIP-Herder";
import DataTable from "react-data-table-component";

const Stock = () => {
  const [stockData, setStockData] = useState([]);
  const [aggregatedStock, setAggregatedStock] = useState([]);
  // const [, setUpdatingStatus] = useState(false);
  // const [poNumbers, setPoNumbers] = useState({});
  const [highlightedData, setHighlightedData] = useState([]); // New State
  const navigate = useNavigate();


    // ** Check Session & Redirect if Not Authenticated **
    const checkAuth = useCallback(() => {
      const authData = sessionStorage.getItem("auth");
      if (!authData) {
        window.location.href = "/wip-login"; // Redirect to login
        return;
      }
  
      const { loggedIn, expiryTime } = JSON.parse(authData);
      if (!loggedIn || Date.now() > expiryTime) {
        sessionStorage.removeItem("auth"); // Clear session
        window.location.href = "/wip-login"; // Redirect to login
      }
    }, []);
  

  // ** Fetch Stock File Data **
  const fetchStockData = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/get-RM-file-Status");
      setStockData(response.data);
    } catch (error) {
      console.error("Error fetching stock data:", error);
    }
  }, []);

  // ** Fetch Aggregated Stock Data **
  const fetchAggregatedStock = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/api/get-aggregated-stock");
      setAggregatedStock(response.data);
    } catch (error) {
      console.error("Error fetching aggregated stock data:", error);
    }
  }, []);

    // ✅ Fetch Highlighted Count Data
    const fetchHighlightedData = useCallback(async () => {
      try {
        const response = await axiosInstance.get("/api/highlighted-count");
        setHighlightedData(response.data);
      } catch (error) {
        console.error("Error fetching highlighted count data:", error);
      }
    }, []);

  useEffect(() => {
    fetchStockData();
    fetchAggregatedStock();
    fetchHighlightedData();
  }, [fetchStockData, fetchAggregatedStock, fetchHighlightedData]);

  // ** Map Aggregated Data **
  const getAggregatedData = (fileName, key) => {
    const found = aggregatedStock.find((item) => item.File_Name === fileName);
    return found ? found[key] : "N/A";
  };

  // ** Handle PO Status Update **
  // const updateStockStatus = async (fileName, newStatus) => {
  //   if (!fileName) return;
  //   setUpdatingStatus(true);
  //   try {
  //     await axiosInstance.patch("/api/update-PO-status", {
  //       fileName,
  //       poStatus: newStatus,
  //     });
  //     alert(`PO Status updated to '${newStatus}' for File: ${fileName}`);
  //     fetchStockData();
  //   } catch (error) {
  //     console.error("Error updating PO status:", error);
  //   } finally {
  //     setUpdatingStatus(false);
  //   }
  // };

   // ** Handle PO Number Update (onBlur) **
  //  const updatePoNumber = async (fileName, newPoNumber) => {
  //   try {
  //     await axiosInstance.patch("/api/update-po-number", {
  //       fileName,
  //       PO_Number: newPoNumber || null, // Allow NULL values
  //     });

  //     // Update UI Immediately
  //     setPoNumbers((prev) => ({ ...prev, [fileName]: newPoNumber || "" }));
  //     alert(`PO Number updated for File: ${fileName} -> ${newPoNumber || "NULL"}`);
  //   } catch (error) {
  //     console.error("Error updating PO Number:", error);
  //   }
  // };

      // ** Run Session Check & Fetch Data **
      useEffect(() => {
        checkAuth(); // Initial session check
        fetchStockData(); // Fetch data
    
        const interval = setInterval(checkAuth, 1000); // Check session every second
        return () => clearInterval(interval); // Cleanup on component unmount
      }, [checkAuth, fetchStockData]);

       // ✅ Get PO Status Based on Highlighted Data
  const getPoStatus = (fileName) => {
    const found = highlightedData.find((item) => item.File_Name === fileName);
    return found && found.Remaining_Highlighted === 0 ? "PO Raised" : "PO Not Raised";
  };

  // ** Table Columns **
  const columns = [
    { name: "Sr", selector: (_, index) => index + 1, sortable: true, width: "70px" },
    {
      name: "File Name",
      cell: (row) => (
        <button
          onClick={() => navigate(`/stock-details/${encodeURIComponent(row.File_Name)}`)}
          style={{
            background: "none",
            border: "none",
            color: "blue",
            textDecoration: "None",
            textTransform: "uppercase",
            cursor: "pointer",
          }}
        >
          {row.File_Name}
        </button>
      ),
      sortable: true,
    },
    // { name: "Stock In Hand", selector: (row) => getAggregatedData(row.File_Name, "Total_Stock_In_Hand"), sortable: true },
    { name: "Plan Qty", selector: (row) => getAggregatedData(row.File_Name, "Total_Plan_Qty"), sortable: true },
    // {
    //   name: "Shortage",
    //   selector: (row) => getAggregatedData(row.File_Name, "Total_Shortage"),
    //   sortable: true,
    //   cell: (row) => (
    //     <span style={{ color: "red", fontWeight: "bold" }}>
    //       {getAggregatedData(row.File_Name, "Total_Shortage")}
    //     </span>
    //   ),
    // },
    {
      name: "Shortage",
      selector: (row) => getAggregatedData(row.File_Name, "Total_Shortage"),
      sortable: true,
      cell: (row) => {
        const totalShortage = getAggregatedData(row.File_Name, "Total_Shortage") || "N/A"; // Get aggregated shortage
        const hasPO = row.PO_Number && row.PO_Number.trim() !== "N/A"; // Check if PO number exists
    
        return (
          <span style={{ 
            color: !hasPO ? "red" : "black", // Remove red if PO is available
           
          }}>
            {totalShortage}
          </span>
        );
      }
    },    
    { name: "Uploaded Date", selector: (row) => row.Uploaded_Date, sortable: true },
    // { name: "PO Number", selector: (row) => row.PO_Number, sortable: true },
    // {
    //   name: "PO Number",
    //   cell: (row) => (
    //     <input
    //       type="text"
    //       className="form-control"
    //       placeholder="Enter PO Number"
    //       value={poNumbers[row.File_Name] ?? row.PO_Number ?? ""}
    //       onBlur={(e) => updatePoNumber(row.File_Name, e.target.value)}
    //       onChange={(e) => setPoNumbers({ ...poNumbers, [row.File_Name]: e.target.value })}
    //       style={{ width: "140px", fontSize: "14px" }}
    //     />
    //   ),
    //   sortable: true,
    // },
     // ✅ PO Status Column Based on Remaining_Highlighted Count
    {
      name: "PO Status",
      cell: (row) => {
        const status = getPoStatus(row.File_Name);
        const displayStatus = status === "PO Raised" ? "Ready for Upload" : "PO Not Raised"; // Rename UI display
        return (
          <span
            style={{
              backgroundColor: status === "PO Raised" ? "green" : "red",
              color: "white",
              padding: "5px 10px",
              borderRadius: "5px",
              fontWeight: "bold",
            }}
          >
            {displayStatus}
          </span>
        );
      },
      sortable: true,
    },
  ];

  return (
    <div>
      <WIPHeader />
      <div className="d-flex justify-content-end mt-4" style={{ marginRight: "40px" }}>
        <button className="btn btn-secondary" onClick={() => navigate("/rm-shortage")} style={{ marginRight: "10px" }}>
          RM Shortage →
        </button>
        <button className="btn btn-secondary" onClick={() => navigate("/box-rm-shortage")}>
          Inventory →
        </button>
      </div>

      <div className="p-4" style={{marginTop: "-30px"}}>
        <h1 className="mb-4">Stock Management</h1>

        {/* ✅ DataTable Integration */}
        <DataTable
          columns={columns}
          data={stockData}
          pagination
          highlightOnHover
        />
      </div>
    </div>
  );
};

export default Stock;
